<template>

  <div class="form newContestant">

    <form v-if="isWaiting" name="newContestant" @submit.prevent="registerContestant">

      <div class="formGroup">
        <span class="formGroup__label">Alias<i class="formGroup__req">*</i></span>
        <input class="formGroup__input" type="text" v-model="newContestant.alias">
      </div>

      <div class="register__form-columned">
        <div class="formGroup">
          <span class="formGroup__label">Ime<i class="formGroup__req">*</i></span>
          <input class="formGroup__input" type="text" v-model="newContestant.name">
        </div>

        <div class="formGroup">
          <span class="formGroup__label">Prezime<i class="formGroup__req">*</i></span>
          <input class="formGroup__input" type="text" v-model="newContestant.surname">
        </div>
      </div>

      <div class="formGroup">
        <span class="formGroup__label">E-mail<i class="formGroup__req">*</i></span>
        <input class="formGroup__input" type="text" v-model="newContestant.email">
      </div>

      <div class="formGroup">
        <span class="formGroup__label">Status<i class="formGroup__req">*</i></span>
        <label class="formGroup__radio">
          <input type="radio" name="status" value="student" v-model="newContestant.status"> Student
        </label>
        <label class="formGroup__radio">
          <input type="radio" name="status" value="pupil" v-model="newContestant.status"> Učenik
        </label>
        <label class="formGroup__radio">
          <input type="radio" name="status" value="other" v-model="newContestant.status"> Ostalo
        </label>
      </div>

      <div class="formGroup" v-if="isStudent || isPupil">
        <span class="formGroup__label" v-if="isStudent">Fakultet</span>
        <span class="formGroup__label" v-if="isPupil">Škola</span>
        <input class="formGroup__input" type="text" v-model="newContestant.school">
      </div>

      <div class="formGroup" v-if="isStudent">
        <label class="formGroup__radio">
          <input type="checkbox" v-model="newContestant.natprog"> Upisao sam natprog na FER-u</i>
        </label>
      </div>

      <hr>

      <div class="formGroup">
        <label class="formGroup__radio">
          <input type="checkbox" v-model="newContestant.tos"> Prihvaćam <a href="https://drive.google.com/file/d/1qgeA0RAU68FdLhSCjP3R3uWQ4Znsonnk/view?usp=sharing" target="_blank">Opća pravila natjecanja</a><i class="formGroup__req">*</i>
        </label>
      </div>

      <div class="formGroup">
        <label class="formGroup__radio">
          <input type="checkbox" v-model="newContestant.gdpr"> Prihvaćam <a href="https://drive.google.com/file/d/1KNfSVPWlpWMmMbEKG7Z5cEfEOVTaMqXM/view?usp=sharing" target="_blank">Pravila o obradi podataka</a><i class="formGroup__req">*</i>
        </label>
      </div>

      <input type="input" class="formGroup__honey" v-model="newContestant.honey" aria-hidden="true" tabindex="-1">
      <button type="submit" class="formGroup__button" :class="{ 'formGroup__button--visible': isValidForm }">Prijava</button>

    </form>
    <template v-else>
      <div v-if="isNetworking">
        <h3>Slanje podataka...</h3>
      </div>
      <div v-if="isDuplicate">
        <h3>Problem!</h3>
        <p>Korisnik s navedenim podacima već je registriran.</p>
      </div>
      <div v-if="isSuccess">
        <h3>Bravo!</h3>
        <p>Uspješno si se prijavio na natjecanje. Rješenja ćeš predati koristeći svoj e-mail, a sve javne objave idu pod aliasom <strong>{{ this.newContestant.alias }}</strong>.</p>
      </div>
    </template>

  </div>

</template>
<script>
import axios from 'axios'
axios.defaults.headers.common['Authorization'] = Date.now()
const apiUrl = `https://api.suncobraniranje.phishar.com/newContestant`
export default {
  data() {
    return {
      remote: {
        status: 'waiting'
      },
      newContestant: {
        alias: '',
        name: '',
        surname: '',
        email: '',
        status: 'student',
        natprog: false,
        gdpr: false,
        tos: false,
        school: '',
        honey: ''
      }
    }
  },
  props: ['inputEmail'],
  computed: {
    storageAlias() {
      return window.localStorage.getItem('suncobraniranjeAlias') || null
    },
    isInMemory() {
      return this.storageAlias !== null
    },
    isWaiting() {
      return this.storageAlias === null && this.remote.status === 'waiting'
    },
    isSuccess() {
      return this.remote.status === 'success'
    },
    isDuplicate() {
      return this.remote.status === 'duplicate'
    },
    isNetworking() {
      return this.remote.status === 'networking'
    },
    isPupil() {
      return this.newContestant.status === 'pupil'
    },
    isStudent() {
      return this.newContestant.status === 'student'
    },
    isEmailValid() {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.newContestant.email)
    },
    isValidForm() {

      if (this.newContestant.alias.trim() === '') return false
      if (this.newContestant.name.trim() === '') return false
      if (this.newContestant.surname.trim() === '') return false
      if (!this.isEmailValid) return false
      if (!this.newContestant.gdpr) return false
      if (!this.newContestant.tos) return false
      if (this.newContestant.honey !== '') return false

      return true
    }
  },
  methods: {
    async registerContestant() {
      if (!this.isValidForm) return false
      if (this.isNetworking) return false

      this.remote.status = 'networking'

      const formData = new FormData()
      for (let key of Object.keys(this.newContestant)) {
        formData.append(key, this.newContestant[key])
      }

      await axios
      .post(apiUrl, formData)
      .then(response => {
        window.localStorage.setItem('suncobraniranjeAlias', this.newContestant.alias)
        this.remote.status = 'success'
        this.$emit('email', this.newContestant.email)
      })
      .catch(error => {
        const status = error.response.status

        if (status === 409) {
          this.remote.status = 'duplicate'
        }
      })

    }
  },
  mounted() {
    if (this.inputEmail !== '') {
      this.newContestant.email = this.inputEmail
    }
  }
}
</script>
